import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowService {

  public getCliCoreNameFromHost(): string {
    const hostname = window.location.hostname;
    return hostname.slice(0, hostname.indexOf('.'));
  }

  public isStaticImageAvailable(imageName: string): boolean {
    const staticConfig = window['staticConfig'];
    return staticConfig && staticConfig[imageName];
  }

  public setBackgroundImage(cssRule: string, backgroundImageUrl: string): void {
    window['setBackground'](cssRule, backgroundImageUrl);
  }

  public isSelectionActive() {
    return !window.getSelection().isCollapsed;
  }
}
